import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Ba1110Class}from '../../Class/ba1110/ba1110-class'
import{Ba4010Class}from '../../Class/ba4010/ba4010-class'
import {environment} from '../../../environments/environment'
import { WIDGET0004Class } from '../../Class/WIDGET0004/widget0004-class';
import { WIDGET0005Class } from '../../Class/WIDGET0005/widget0005-class';
import { ADM0009Class } from '../../Class/ADM0009/adm0009-class';

@Injectable({
  providedIn: 'root'
})
export class WIDGET0004ServiceService {

  baseUrl: string=environment.baseUrl + 'WIDGET0004/';
    reportUrl: string=  environment.reportUrl;
  constructor(private http:HttpClient) { }

LoadControls():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadControls');
}
GetCommonControlNames(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
}

LoadAnnouncement():Observable<any>
{

  return this.http.get<any>(this.baseUrl+'LoadAnnouncement');
}

GetCountAnnouncement():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCountAnnouncement');
}

GetControlNames():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetControlNames');
}

//Load saved data in to find section
LoadFind():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadFind');
}

DoFind(id):Observable<any>
{

  return this.http.get<any>(this.baseUrl+'doFind/'+id);
}
//Add or Edit an entry
Create(announcement_class:ADM0009Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl+'Create',announcement_class);
}
Delete(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Delete/'+id);
}
Adm0009(objAdm0009Class:WIDGET0004Class): Observable<any>
{
  return this.http.post(this.reportUrl+'Adm0009Controller/Adm0009', objAdm0009Class, {responseType: 'blob'});
}

Adm0009Excel(objAdm0009Class:WIDGET0004Class): Observable<any>
{
  return this.http.post(this.reportUrl+'Adm0009Controller/Adm0009Excel', objAdm0009Class);
}

}
